<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          支付状态
        </div>
        <el-select
          v-model="searchForm.registrationStatus"
          placeholder="请选择支付状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in registrationStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <div class="label">
          课程类型
        </div>
        <el-select
          v-model="searchForm.courseCategoryId "
          placeholder="请选择课程类型"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in courseCategoryList"
            :key="item.value"
            :label="item.value"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.searchValue"
          placeholder="请输入学员姓名/身份证号/课程名称"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <orderDialog
      :dialog-visible.sync="refundVisible"
      :refund-id="refundId"
    />
    <orderAgencyDialog
      :dialog-visible.sync="orderAgencyVisible"
      :course-registration-id="courseRegistrationId"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import orderDialog from '@/components/common/orderDialog.vue';
import orderAgencyDialog from '@/components/common/orderAgencyDialog.vue';
import types, { registrationStatusList } from '@/config';

export default {
  name: 'Order',
  components: {
    dataTable,
    orderDialog,
    orderAgencyDialog,
  },
  data() {
    return {
      registrationStatusList,
      courseCategoryList: [],
      refundId: null,
      courseRegistrationId: null,
      refundVisible: false,
      orderAgencyVisible: false,
      searchForm: {
        courseCategoryId: '',
        searchValue: '',
        registrationStatus: '',
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      tableColumn: [
        {
          key: 'registrationNo',
          label: '订单编号',
          width: '200px',
          dataType: 'text',
        },
        {
          key: 'realName',
          label: '学员姓名',
          width: '80px',
          dataType: 'text',
        },
        {
          key: 'mobilePhone',
          label: '学员电话',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'courseName',
          label: '购买课程',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'refundReason',
          label: '退款原因',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'courseCategoryName',
          label: '课程类型',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agencyName',
          label: '机构名称',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'payAmount',
          label: '支付金额',
          width: '80px',
          dataType: 'money',
        },
        {
          key: 'registrationStatus',
          label: '状态',
          width: '100px',
          dataType: 'function',
          render: (key) => registrationStatusList.filter((item) => item.value === key),
        },
        {
          key: 'createTime',
          label: '下单时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '240px',
          dataType: 'component',
          renderProps: [
            {
              text: '退款', renderKey: types.IS_REFUND, renderProp: 'isRefund', type: 'success', eventIndex: 0, disableKey: null,
            },
            {
              text: '已退款', renderKey: types.IS_NO_REFUND, renderProp: 'isRefund', type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '修改机构', renderKey: null, renderProp: null, type: 'primary', eventIndex: 2, disableKey: null,
            },
            {
              text: '查看', renderKey: null, type: 'info', eventIndex: 3, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.getCategoryList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.order.pageCourseRegistrationListBackend(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 下拉列表
    async getCategoryList() {
      const all = {
        id: '',
        value: '全部',
      };
      this.courseCategoryList = await axClient.course.listCategoryName();
      this.courseCategoryList = [all, ...this.courseCategoryList];
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'OrderDetails', params: { orderId: item.id } });
    },
    // 退款详情弹窗
    refundDialog(item) {
      this.refundVisible = true;
      this.refundId = item.id;
    },
    agencyDialog(item) {
      this.orderAgencyVisible = true;
      this.courseRegistrationId = item.id;
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.refundDialog(item);
          break;
        case 2:
          this.agencyDialog(item);
          break;
        case 3:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  .header {
    padding: 16px 0;
    display: flex;
    justify-content: space-between;
    .l {
      display: flex;
      align-items: center;
      .label {
        font-weight: 500;
        font-size: 14px;
        margin-right: 12px;
        min-width: 50px;
      }
      .el-select {
        margin-right: 15px;
        flex: 1;
      }
    }
    .r {
      min-width: 300px;
      display: flex;
      align-items: center;
      & > .el-button {
        flex: 1;
        margin-left: 15px;
        min-width: auto;
      }
    }
  }
}
</style>
